// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueSession from 'vue-session'
import IdleVue from 'idle-vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'

import '@fortawesome/fontawesome-free/css/fontawesome.min.css'
import '@fortawesome/fontawesome-free/css/solid.min.css'

import App from './App'
import router from './router'

Vue.use(VueSession)
Vue.use(IdleVue, {eventEmitter: new Vue(), idleTime: 30 * 60 * 1000})
Vue.use(Buefy, {defaultIconPack: 'fas'})
Vue.config.productionTip = false

Vue.filter('toLocaleString', function (value) {
  return value.toLocaleString()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {App},
  template: '<App/>',
  onIdle () {
    this.$session.destroy()
    this.$router.push('/login?isIdle=true')
  }
})



// WEBPACK FOOTER //
// ./src/main.js